import React from "react";

const PurpleHouseIcon = ({width="16",height="16"}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 7.5V14.25C15 15.0784 14.3284 15.75 13.5 15.75H4.5C3.67157 15.75 3 15.0784 3 14.25V7.5M15 7.5L16.5 9M15 7.5L9 1.5L3 7.5M3 7.5L1.5 9M6.75 15.75V9H11.25V15.75M12 4.5V2.25H14.25V6.75"
        stroke="#B780FF"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default PurpleHouseIcon;
